module.exports = "/_next/static/images/8ea171eafa593d096ed802b4d10e96d5-blog3a-xs.jpg.webp";